import React, { useState, useEffect } from "react";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function CategoryList() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    useEffect(() => {
        fetchBannersData();
    }, []);
    const fetchBannersData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "maincategories";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="category-container">
            {dataSource?.map((cat, i) => (
                <div key={i} className="category-item">
                    <div className="category-image">
                        <img src={cat?.image_url} alt={cat?.maincategory_name} />
                    </div>
                    <span className="category-name">{cat?.maincategory_name}</span>
                </div>
            ))}
        </div>
    );
}